import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { fireErrorAnalyticsEvents } from '@atlassian/jira-servicedesk-knowledge-common/src/common/utils';
import {
	addLabelsToArticles,
	type AddLabelsResponse,
} from '@atlassian/jira-servicedesk-knowledge-services';
import {
	ADD_LABELS_TO_ARTICLE,
	type AddLabelsToArticleAction,
} from '../../state/actions/add-labels-to-article';
import { addLabelsToArticleFailure } from '../../state/actions/add-labels-to-article-failure';
import { addLabelsToArticleSuccess } from '../../state/actions/add-labels-to-article-success';
import { getActivationId, getProjectId } from '../../state/selectors/base';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(ADD_LABELS_TO_ARTICLE).mergeMap((action: AddLabelsToArticleAction) => {
		const { labels, articleId, spaceKey, analyticsEvent } = action.payload;
		const projectId = getProjectId(store.getState());
		const activationId = getActivationId(store.getState());
		return addLabelsToArticles({
			projectId,
			labels,
			articleId,
			spaceKey,
			activationId,
		})
			.map((response: AddLabelsResponse) => {
				fireTrackAnalytics(analyticsEvent, 'onAddLabels success', {
					articleId,
				});
				return addLabelsToArticleSuccess(response);
			})
			.catch((error) => {
				fireErrorAnalyticsEvents(error, 'onAddLabelsFailure', PACKAGE_NAME);
				return Observable.of(
					addLabelsToArticleFailure({
						articleId,
					}),
				);
			});
	});
